/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { MenuItem, TextField } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCommonDropdownList,
  isNumeric,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  sysReminderSetupList,
  dispatchCheckLogErrorMsg,
} from '../store/actions';

const CheckLog = (props) => {
  const dispatch = useDispatch();
  const [commonDropdownList, setCommonDropdownList] = useState({});
  const [curIndex, setCurIndex] = useState();
  const [reminderList, setReminderList] = useState();
  const reminder_list = useSelector(
    (state) => state?.sharedState?.ReminderSetupReducer?.reminder_list
  );
  const getInputValue = useSelector((state) => {
    return state.sharedState.ReminderSetupReducer.getInputValue;
  });
  const getCheckLogErrorMsg = useSelector((state) => {
    return state.sharedState.ReminderSetupReducer.errorMsgCheckLog;
  });
  const newReminderPayload = {
    reminderName: '',
    daysSinceInvPrinted: '',
    checkPayeeCd: 'MD',
  };
  // get reminder list data and assign to the state
  React.useEffect(() => {
    if (reminder_list && reminder_list.length != 0 && curIndex) {
      setReminderList({
        reminderName: reminder_list[curIndex - 1]?.reminderName || '',
        daysSinceInvPrinted:
          reminder_list[curIndex - 1]?.daysSinceInvPrinted || '',
        checkPayeeCd: reminder_list[curIndex - 1]?.checkPayeeCd || '',
      });
    } else if (reminder_list && reminder_list.length === 0) {
      setReminderList(newReminderPayload);
    }
  }, [reminder_list, curIndex]);
  // get InputValue from Redux and assign to the state
  React.useEffect(() => {
    const inputValue = isNumeric(getInputValue);
    if (inputValue && getInputValue) {
      setCurIndex(parseInt(getInputValue));
    } else {
      setCurIndex(getInputValue);
    }
  }, [getInputValue]);
  // get check payee dropdwon data and assign to the state
  React.useEffect(() => {
    getCommonDropdownList({
      codeDomainList: ['CHECK_PAYEE_CD'],
    }).then((res) => {
      setCommonDropdownList(res);
    });
  }, []);
  // handle OnBlur reminder list text fields
  const handleOnBlur = (e) => {
    const type = e.target.name;
    const { value } = e.target;
    let localErr = getCheckLogErrorMsg || [];
    if (type === 'daysSinceInvPrinted') {
      if (value) {
        const rx = /^[0-9]{0,3}?$/;
        if (checkNumberValidation(rx, value)) {
          localErr = localErr?.filter(
            (item) => item.field !== 'daysSinceInvPrinted'
          );
        } else {
          localErr = localErr?.filter(
            (item) => item.field !== 'daysSinceInvPrinted'
          );
          localErr.push({
            field: 'daysSinceInvPrinted',
            errorType: 'daysSinceInvReq',
            message: `Item ${value} does not pass the validation test.`,
          });
        }
      } else if (!value) {
        localErr = localErr?.filter(
          (item) => item.field !== 'daysSinceInvPrinted'
        );
        localErr.push({
          field: 'daysSinceInvPrinted',
          errorType: 'daysSinceInvReq',
          message:
            'Item Days since Check Updated did not pass the validation test.',
        });
      } else {
        localErr = localErr?.filter(
          (item) => item.field !== 'daysSinceInvPrinted'
        );
      }
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchCheckLogErrorMsg(unique));
  };
  // check number validation
  const checkNumberValidation = (rx, amountVal) => {
    let val = false;
    if (rx.test(amountVal?.toString()?.replace('-', '').trim())) {
      val = true;
    }
    return val;
  };
  // on change reminder list text fields
  const handleChange = (e) => {
    if (reminder_list?.length > 0) {
      const type = e.target.name;
      let { value } = e.target;
      const inputValueNum = isNumeric(value);
      if (type === 'daysSinceInvPrinted' && inputValueNum) {
        value = parseInt(e.target.value);
      }
      reminder_list[curIndex - 1][type] = value;
      reminder_list[curIndex - 1].addEditRow = true;

      setReminderList({
        ...reminderList,
        [type]: value,
      });
      dispatch(sysReminderSetupList(reminder_list));
      props.setDisableSaveCancel(true);
    } else {
      props.setDisableSaveCancel(false);
    }
  };
  return (
    <div data-testid="checklog-component">
      <div className="row mb-2">
        <div className="col-4">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">
              Check Payee<span className="mandatory">*</span>
            </legend>
            <div className="form-wrapper p-0 h-100">
              <div className="mui-custom-form with-select field-xl no-lbl d-flex align-items-center">
                <TextField
                  label="Check Payee"
                  fullWidth
                  select
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  id="checkPayeeCd"
                  name="checkPayeeCd"
                  inputProps={{
                    id: 'checkPayeeCd',
                    'aria-label': 'checkPayeeCd',
                  }}
                  value={reminderList?.checkPayeeCd || ''}
                  data-testid="check-payeecd"
                  onChange={handleChange}
                >
                  <MenuItem
                    key=""
                    value={
                      reminderList && reminderList.checkPayeeCd
                        ? reminderList.checkPayeeCd
                        : null
                    }
                    className="frr-dropdown-blank-item"
                  />
                  {commonDropdownList?.CHECK_PAYEE_CD?.map((item, key) => {
                    return (
                      <MenuItem
                        key={item.codeValueID.codeValue}
                        value={item.codeValueID.codeValue}
                      >
                        {item.codeValueID.codeValue} - {item.shortDescription}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div className="row mb-2">
        <div className="col-4">
          <div className="form-wrapper p-0 mt-2">
            <div className="mui-custom-form input-md field-xl">
              <div>
                <TextField
                  label="Reminder Description"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    maxLength: 255,
                    id: 'reminderName',
                    'aria-label': 'reminderName',
                  }}
                  name="reminderName"
                  onChange={handleChange}
                  value={reminderList?.reminderName || ''}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-4">
          <div className="form-wrapper p-0 mt-2">
            <div className="mui-custom-form input-md field-xl">
              <div>
                <TextField
                  label="Days since Check Updated"
                  fullWidth
                  required
                  data-testid="days-sinceinv-printed"
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    maxLength: 4,
                    id: 'daysSinceInvPrinted',
                    'aria-label': 'daysSinceInvPrinted',
                  }}
                  className={
                    getCheckLogErrorMsg?.length > 0
                      ? _.map(getCheckLogErrorMsg, (l) =>
                          l.field == 'daysSinceInvPrinted'
                            ? 'mandate-fields'
                            : null
                        )
                      : null
                  }
                  name="daysSinceInvPrinted"
                  onChange={handleChange}
                  onBlur={handleOnBlur}
                  value={reminderList?.daysSinceInvPrinted || ''}
                  helperText={
                    getCheckLogErrorMsg?.length > 0
                      ? _.map(getCheckLogErrorMsg, (l) =>
                          l.field === 'daysSinceInvPrinted' ? l.message : null
                        )
                      : null
                  }
                  error={
                    getCheckLogErrorMsg?.length > 0
                      ? _.map(getCheckLogErrorMsg, (l) =>
                          l.field == 'daysSinceInvPrinted' ? l.message : null
                        )
                      : null
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CheckLog;
